import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

export const TruncateAndTooltip = ({
  text,
  className,
  data,
  onClickCallback,
  tooltip,
  dataAttributeTest,
  forceTooltipRebuild
}) => {
  const ref = useRef(null)
  const [textTooltip, setTextTooltip] = useState('')

  // useEffect(() => {
  //   setTooltip()
  // }, [])

  const tooltipText = tooltip.text || text

  const rebuildTooltips = () => {
    if (forceTooltipRebuild) {
      ReactTooltip.rebuild()
    }
  }

  useEffect(() => {
    rebuildTooltips()

    return () => {
      rebuildTooltips()
    }
  }, [])

  useEffect(() => {
    setTooltip()
  }, [ref, text, tooltip])

  const setTooltip = () => {
    if (
      tooltip.force ||
      ref.current.offsetWidth < ref.current.children[0].offsetWidth
    ) {
      setTextTooltip(tooltipText)
    } else {
      setTextTooltip('')
    }
  }

  const handleOnCLick = () => {
    onClickCallback(data)
  }

  return (
    <div className={className} data-mu-test={dataAttributeTest}>
      <div
        data-tip={textTooltip}
        className='overflow-ellipis-100'
        ref={ref}
        onClick={handleOnCLick}
      >
        <span>{text}</span>
      </div>
    </div>
  )
}

TruncateAndTooltip.defaultProps = {
  tooltip: {},
  onClickCallback: () => {
    return null
  },
  forceTooltipRebuild: true
}

TruncateAndTooltip.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  tooltip: PropTypes.shape({
    force: PropTypes.bool,
    text: PropTypes.string
  }),
  forceTooltipRebuild: PropTypes.bool
}
